import GiftBaseInfo from '@/src/modules/account/received/GiftBaseInfo'
import CardLinkInfo from '@/src/modules/account/received/CardLinkInfo'
import { IGift } from '@/src/common/queries/FetchReceivedGiftDetails'
import {
    CARD_TO_CARD_ACTION_TYPE_CARD_LINKED,
    MEDIUM_TYPE_VIRTUAL,
    PG_PLUS_NAME,
} from '@/prisma/schemaConstants'
import { currencyFormatter } from '@/src/common/utilities/currencyFormatter'

export interface ITextColumns {
    items: Array<IItem>
}

interface IItem {
    column1: string
    column2: string | number
}

interface IInfoBox {
    giftData: IGift
    refetchGift: Function
}

const GiftInfoBox = ({ giftData, refetchGift }: IInfoBox) => {
    const {
        medium_type,
        brand,
        denomination,
        date_received,
        is_pg_plus,
        gift_id,
        redemption_method,
        redemption_options = { redeemable_via_card_link: false },
    } = giftData

    const denomAsDollars: string = currencyFormatter(denomination)
    const balance: string = currencyFormatter(giftData?.balance ?? 0)

    const isCardLink: boolean =
        redemption_method === CARD_TO_CARD_ACTION_TYPE_CARD_LINKED
    const isVirtualVisa: boolean =
        !redemption_method && medium_type === MEDIUM_TYPE_VIRTUAL
    const isEligibleForCardLink: boolean =
        redemption_options.redeemable_via_card_link

    const giftLabel: string = is_pg_plus || isVirtualVisa ? 'Product' : 'Brand'
    const giftLabelText: string = is_pg_plus
        ? PG_PLUS_NAME
        : isVirtualVisa
        ? `${medium_type} ${brand}`
        : brand

    const columnItems: ITextColumns = {
        items: [
            {
                column1: giftLabel,
                column2: giftLabelText,
            },
            { column1: 'Original value', column2: `${denomAsDollars}` },
            {
                column1: balance ? 'Remaining balance' : '',
                column2: balance,
            },
            {
                column1: date_received ? 'Date received' : '',
                column2: date_received,
            },
        ],
    }

    if (isCardLink || isEligibleForCardLink) {
        const { card_link } = giftData

        const network = card_link?.card_network ?? ''
        const lastFour = card_link?.last_four ?? ''
        const status = card_link?.link_status ?? ''
        const giftId = card_link?.gyp_gift_id ?? ''

        return (
            <GiftBaseInfo columnItems={columnItems} giftId={giftId}>
                <CardLinkInfo
                    card_network={network}
                    last_four={lastFour}
                    link_status={status}
                    brand_name={brand}
                    gyp_gift_id={giftId}
                    is_pg_plus={is_pg_plus}
                    refetchGift={refetchGift}
                />
            </GiftBaseInfo>
        )
    }

    return (
        <GiftBaseInfo
            columnItems={columnItems}
            giftId={gift_id}
            refetchGift={refetchGift}
        />
    )
}

export default GiftInfoBox
